import { createSlice } from "@reduxjs/toolkit";

// Define the initial state for the wizardModalSlice slice
const initialState = {
  appadvisorTurboflowModal: {
    selections: [],
  },
  preProductSelection:{},
  userProductSelectionForExistingOffer:{}
};

// Create the wizardModalSlice slice using createSlice
const wizardModalSlice = createSlice({
  name: "wizardModalSlice", // Slice name
  initialState, // Initial state
  reducers: {
    // Reducer functions to update the state
    updateWizardModal(state, action) {
      state.appadvisorTurboflowModal =
        action.payload.appadvisorTurboflowModal ??
        state.appadvisorTurboflowModal;
        state.preProductSelection =
        action?.payload?.preProductSelection ?? state?.preProductSelection;
        state.userProductSelectionForExistingOffer=
        action?.payload?.userProductSelectionForExistingOffer ?? state.userProductSelectionForExistingOffer
    },

    resetWizardModal(state, action) {
        state.appadvisorTurboflowModal = initialState.appadvisorTurboflowModal
        state.preProductSelection = initialState.preProductSelection;
        state.userProductSelectionForExistingOffer=initialState.userProductSelectionForExistingOffer
    },
  },
});

// Export the reducer functions as actions
export const {
  updateWizardModal,
  resetWizardModal
} = wizardModalSlice.actions;
// Export the reducer function itself
export default wizardModalSlice.reducer;
